import { render, staticRenderFns } from "./ExpertAdd.vue?vue&type=template&id=3bc2d276"
import script from "./ExpertAdd.vue?vue&type=script&lang=js"
export * from "./ExpertAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports